var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "유해위험기계기구 기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.editable &&
                                  _vm.popupParam.hhmHazardousMachineryId,
                                expression:
                                  "editable&&popupParam.hhmHazardousMachineryId",
                              },
                            ],
                            attrs: {
                              isSubmit: _vm.isDeleteAuth,
                              url: _vm.deleteAuthUrl,
                              param: _vm.equipInfo,
                              mappingType: "PUT",
                              label: "삭제",
                              icon: "delete",
                              auth: "SAFHEA",
                            },
                            on: {
                              beforeAction: _vm.deleteAuth,
                              btnCallback: _vm.deleteAuthCallback,
                            },
                          }),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.equipInfo,
                                  mappingType: _vm.saveType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveInfo,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            label: "형식(규격)",
                            name: "machineryName",
                          },
                          model: {
                            value: _vm.equipInfo.machineryName,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "machineryName", $$v)
                            },
                            expression: "equipInfo.machineryName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            name: "machineryClassification",
                            label: "설비종류",
                          },
                          model: {
                            value: _vm.equipInfo.machineryClassification,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.equipInfo,
                                "machineryClassification",
                                $$v
                              )
                            },
                            expression: "equipInfo.machineryClassification",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            afterIcon: [
                              {
                                name: "search",
                                click: true,
                                callbackName: "add",
                                color: "teal",
                              },
                              {
                                name: "close",
                                click: true,
                                callbackName: "remove",
                                color: "red",
                              },
                            ],
                            editable: _vm.editable,
                            label: "설비번호",
                            close: false,
                            name: "equipmentNo",
                          },
                          on: { add: _vm.add, remove: _vm.remove },
                          model: {
                            value: _vm.equipInfo.equipmentNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "equipmentNo", $$v)
                            },
                            expression: "equipInfo.equipmentNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "설비위치",
                            name: "emplacementPlace",
                          },
                          model: {
                            value: _vm.equipInfo.emplacementPlace,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "emplacementPlace", $$v)
                            },
                            expression: "equipInfo.emplacementPlace",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "QR번호",
                            name: "qrNumber",
                          },
                          model: {
                            value: _vm.equipInfo.qrNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "qrNumber", $$v)
                            },
                            expression: "equipInfo.qrNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "용량",
                            name: "volume",
                          },
                          model: {
                            value: _vm.equipInfo.volume,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "volume", $$v)
                            },
                            expression: "equipInfo.volume",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "개",
                            editable: _vm.editable,
                            label: "수량",
                            name: "amount",
                            type: "number",
                          },
                          model: {
                            value: _vm.equipInfo.amount,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "amount", $$v)
                            },
                            expression: "equipInfo.amount",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-dept-multi", {
                          attrs: {
                            type: "edit",
                            label: "담당부서",
                            name: "departmentDeptCd",
                          },
                          model: {
                            value: _vm.equipInfo.departmentDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "departmentDeptCd", $$v)
                            },
                            expression: "equipInfo.departmentDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.editable,
                            label: "담당자",
                            type: "user",
                            name: "departmentUserId",
                          },
                          model: {
                            value: _vm.equipInfo.departmentUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "departmentUserId", $$v)
                            },
                            expression: "equipInfo.departmentUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.equipInfo.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "plantCd", $$v)
                            },
                            expression: "equipInfo.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            isFlag: true,
                            editable: _vm.editable,
                            label: "사용여부",
                            name: "useFlag",
                          },
                          model: {
                            value: _vm.equipInfo.useFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "useFlag", $$v)
                            },
                            expression: "equipInfo.useFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            label: "비고",
                            rows: 2,
                            name: "remark",
                          },
                          model: {
                            value: _vm.equipInfo.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "remark", $$v)
                            },
                            expression: "equipInfo.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "안전검사정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            isFlag: true,
                            editable: _vm.editable,
                            label: "안전인증 대상",
                            name: "certificateSubjectFlag",
                          },
                          model: {
                            value: _vm.equipInfo.certificateSubjectFlag,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.equipInfo,
                                "certificateSubjectFlag",
                                $$v
                              )
                            },
                            expression: "equipInfo.certificateSubjectFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            isFlag: true,
                            editable: _vm.editable,
                            label: "자율안전확인신고대상",
                            name: "autoSafetyFlag",
                          },
                          model: {
                            value: _vm.equipInfo.autoSafetyFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "autoSafetyFlag", $$v)
                            },
                            expression: "equipInfo.autoSafetyFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            isFlag: true,
                            editable: _vm.editable,
                            trueLabel: "대상",
                            falseLabel: "비대상",
                            label: "안전검사 대상",
                            name: "inspectionSubjectFlag",
                          },
                          model: {
                            value: _vm.equipInfo.inspectionSubjectFlag,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.equipInfo,
                                "inspectionSubjectFlag",
                                $$v
                              )
                            },
                            expression: "equipInfo.inspectionSubjectFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            editable: _vm.editable,
                            type: "edit",
                            codeGroupCd: "MDM_EQUIP_CYCLE_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            label: "검사주기",
                            name: "inspectionCycle",
                          },
                          model: {
                            value: _vm.equipInfo.inspectionCycle,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "inspectionCycle", $$v)
                            },
                            expression: "equipInfo.inspectionCycle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "안전인증(자율안전)번호",
                            name: "safetyNumber",
                          },
                          model: {
                            value: _vm.equipInfo.safetyNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.equipInfo, "safetyNumber", $$v)
                            },
                            expression: "equipInfo.safetyNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }